import { render } from "./EditPlace.vue?vue&type=template&id=ea6ff23e&ts=true"
import script from "./EditPlace.vue?vue&type=script&lang=ts"
export * from "./EditPlace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__